import { IReportContextValue } from "../../models/comodel/mergefieldsmodel.model";

export class GenerateReportModel {  
    headerOnFirstPage: boolean;
    footerOnFirstPage: boolean;
    useBanner: boolean;
    usePageNumberHeader: boolean;
    formatAsLetter: boolean;
    htmlHeader: string;
    html: string;
    htmlFooter: string;
    organizationId: string;
    organizationName: string;
    applicationNumber: string;
    documentTypeName: string;
    flowId?: string;
    mergeFields: IReportContextValue[] = [];
    //The default color is green, but styling is off by default
    styleMergeFields: boolean;
    mergeFieldStylePrefix?: string = '<span style="color: rgb(41, 130, 29);">';
    mergeFieldStyleSuffix?: string = '</span>';

    public constructor() { }

    public replaceContentWithMergeFields() {
        if (this.htmlHeader != null)
            this.htmlHeader = this._replaceContentWithMergeFields(this.htmlHeader);
        if (this.html != null)
            this.html = this._replaceContentWithMergeFields(this.html);
        if (this.htmlFooter != null)
            this.htmlFooter = this._replaceContentWithMergeFields(this.htmlFooter);
    }

    private _replaceContentWithMergeFields(content: string): string {
        for (let x = 0; x < this.mergeFields.length; x++) {

            let formattedMergeFieldToReplace = '[' + this.mergeFields[x].contextValue + ']';

            //If the content includes the merge field token
            if (content.includes(formattedMergeFieldToReplace)) {

                //And if a replace value was provided for it
                if (this.mergeFields[x].replaceValue != null && this.mergeFields[x].replaceValue != '') {
                    let replaceValue = "";
                    if (this.styleMergeFields)
                        replaceValue = this.mergeFieldStylePrefix + this.mergeFields[x].replaceValue + this.mergeFieldStyleSuffix;
                    else
                        replaceValue = this.mergeFields[x].replaceValue;
                    while (content.includes(formattedMergeFieldToReplace))
                        content = content.replace(formattedMergeFieldToReplace, replaceValue);
                }
                else {
                    //We don't want to keep brackets because of how we're doing this in a while loop, the while would never end if we replace the string we're 
                    //looking for with a string in which original search value is a substring as well
                    let contextValue = "";
                    if (this.styleMergeFields)
                        contextValue = this.mergeFieldStylePrefix + this.mergeFields[x].contextValue + this.mergeFieldStyleSuffix;
                    else
                        contextValue = this.mergeFields[x].contextValue;

                    while (content.includes(formattedMergeFieldToReplace))
                        content = content.replace(formattedMergeFieldToReplace, contextValue);
                }
            }
        }

        return content;
    }
}


export class RegenerateRequeueRequest extends GenerateReportModel {
    existingQueueItem: string;
    isPaid: boolean;

    constructor() {
        super();
    }
}

export interface InvoiceReceiptRegenerateResult {
    queueItem: string;
    fileName: string;
    exception: any;
}